/* =====================================================================
   UNIVERSEPARFUMS — Hero Slider
   - Autoplay avec pause au hover (desktop) / touch (mobile)
   - Navigation par dots (clic = goto)
   - Cross-fade pur (gestion via classes is-active)
   - Animation de progression sur le dot actif
   - Reset propre au resize / changement de slide manuel
   ===================================================================== */
(function () {
  'use strict';

  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.up-hero__slide'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('.up-hero__dot'));
    if (slides.length <= 1) return; // 0 ou 1 slide = rien à animer

    var current   = 0;
    var autoplay  = root.dataset.autoplay === 'true';
    var duration  = parseInt(root.dataset.duration || '5', 10) * 1000;
    var timer     = null;
    var isPaused  = false;

    /* ---------- Affichage d'une slide ---------- */
    function setActive(index) {
      if (index === current) return;
      // Borne (au cas où)
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      // Désactiver les liens/boutons de la slide qui sort
      var ctaOut = slides[current].querySelector('.up-hero__cta');
      if (ctaOut) ctaOut.setAttribute('tabindex', '-1');

      slides[index].classList.add('is-active');
      slides[index].setAttribute('aria-hidden', 'false');
      var ctaIn = slides[index].querySelector('.up-hero__cta');
      if (ctaIn) ctaIn.setAttribute('tabindex', '0');

      // Dots
      dots.forEach(function (d, i) {
        var active = i === index;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      current = index;
      restartProgress();
    }

    /* ---------- Animation de progression sur le dot actif ---------- */
    function restartProgress() {
      // Reset toutes les barres
      dots.forEach(function (d) {
        var fill = d.querySelector('.up-hero__dot-fill');
        if (!fill) return;
        // Reset sans transition pour repartir de 0
        fill.style.transition = 'none';
        fill.style.width = '0';
      });

      if (!autoplay || isPaused) return;

      // Force un reflow puis lance la barre du dot actif
      var activeFill = dots[current] && dots[current].querySelector('.up-hero__dot-fill');
      if (!activeFill) return;

      // eslint-disable-next-line no-unused-expressions
      activeFill.offsetHeight; // reflow

      activeFill.style.transition = 'width ' + duration + 'ms linear';
      activeFill.style.width = '100%';
    }

    /* ---------- Autoplay ---------- */
    function play() {
      stop();
      if (!autoplay || isPaused) return;
      timer = window.setTimeout(function () {
        next();
      }, duration);
      restartProgress();
    }

    function stop() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function next() {
      setActive((current + 1) % slides.length);
      play();
    }

    function pause() {
      isPaused = true;
      stop();
      // Geler la barre de progression à sa position actuelle
      var activeFill = dots[current] && dots[current].querySelector('.up-hero__dot-fill');
      if (activeFill) {
        var computed = window.getComputedStyle(activeFill).width;
        activeFill.style.transition = 'none';
        activeFill.style.width = computed;
      }
    }

    function resume() {
      if (!isPaused) return;
      isPaused = false;
      play();
    }

    /* ---------- Navigation manuelle (dots) ---------- */
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var target = parseInt(d.dataset.slideTarget || '0', 10);
        setActive(target);
        play();
      });
    });

    /* ---------- Pause hover (desktop) / touch (mobile) ---------- */
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);

    // Mobile touch : pause pendant l'interaction puis reprend
    var touchTimer = null;
    root.addEventListener('touchstart', function () {
      pause();
      if (touchTimer) window.clearTimeout(touchTimer);
    }, { passive: true });

    root.addEventListener('touchend', function () {
      // Petit délai avant de relancer pour laisser l'utilisateur lire
      if (touchTimer) window.clearTimeout(touchTimer);
      touchTimer = window.setTimeout(resume, 2500);
    }, { passive: true });

    /* ---------- Pause quand l'onglet n'est plus visible ---------- */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else resume();
    });

    /* ---------- Init ---------- */
    play();
  }

  function init() {
    document.querySelectorAll('[data-up-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init dans l'éditeur de thème quand une section est rechargée
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-up-hero]');
    if (hero) initHero(hero);
  });
})();
